import React from "react";
import { useTranslation } from "react-i18next";
import { QMenuButton, QMenuItem } from "@qualio/ui-components";
import { DesignElementVersion } from "@design-controls/types";
import {
  toDesignElementVersionLabel,
  toDesignElementVersionNumber,
} from "../../../domain/designElementVersion";

type Props = {
  versions: DesignElementVersion[];
  selected: DesignElementVersion;
  onSelect: (version: DesignElementVersion) => void;
  "data-cy": string;
};

export const CompareVersionSelect: React.FC<Props> = ({
  versions,
  selected,
  onSelect,
  "data-cy": dataCy,
}) => {
  const { t } = useTranslation();

  const versionNumber = (version: DesignElementVersion) =>
    toDesignElementVersionNumber(toDesignElementVersionLabel(version));

  return (
    <QMenuButton
      buttonLabel={t("designElementCompare.comparingLabel", {
        version: versionNumber(selected),
      })}
      variant="ghost"
      isDisabled={versions.length <= 1}
      data-cy={dataCy}
    >
      {versions.map((version) => {
        const isCurrent = version.version === selected.version;

        return (
          <QMenuItem
            key={version.version}
            onClick={() => onSelect(version)}
            bg={isCurrent ? "gray.100" : undefined}
            aria-current={isCurrent ? "true" : undefined}
            data-cy={`${dataCy}-${toDesignElementVersionLabel(version)}`}
          >
            {t("designElementVersions.label", {
              version: versionNumber(version),
            })}
          </QMenuItem>
        );
      })}
    </QMenuButton>
  );
};
